import {UmpireImage} from '../umpire-image';
import {UmpireExternalProviderPointer} from '../umpire-external-provider-pointer';
import {UmpireSquadPlayer} from '../umpire-squad-player';
import {UmpireClub} from '../umpire-club';

export interface UmpirePlayer {
  client_id: number;

  date_of_birth: string | null;

  country_code: string | null;

  external_provider_pointers: UmpireExternalProviderPointer[] | null;

  first_name: string | null;

  height: number | null;

  id: string;

  last_name: string | null;

  relationshipNames: string[];

  short_name: string | null;

  instagram_url: string | undefined;

  facebook_url: string | undefined;

  spotify_url: string | undefined;

  twitter_url: string | undefined;

  type: string;

  image: UmpireImage;

  squad_players: UmpireSquadPlayer[];

  slug: string | null;

  career_clubs: UmpirePlayerCareerClubs[];
}

export interface UmpirePlayerCareerClubs {
  date_from: string;
  date_to: string | null;
  club: UmpireClub;
}

export interface UmpirePlayerCareer {
  date_from: string;
  date_to: string | null;
  club_id: string;
}
